import Login from "../../views/pages/authentication/Login.vue";
import ForgotPassword from "../../views/pages/authentication/ForgotPassword.vue";
import SetupMFA from "../../views/pages/authentication/SetupMFA.vue";
import VerifyMFA from "../../views/pages/authentication/VerifyMFA.vue";
import ValidateMFA from "../../views/pages/authentication/ValidateMFA.vue";
import Profile from "../../views/pages/user-profile/view.vue";
import ResetPassword from "../../views/pages/authentication/ResetPassword";
import NotFound from "../../views/pages/NotFound.vue";
import SalesforceIntegration from "../../views/integrations/salesforce";
import HubspotIntegration from "../../views/integrations/hubspot";

import VoxoMobile from "@/views/mobile/view";
import SSOProcessing from "@/views/pages/authentication/SSOProcessing";

import layouts from "../../layout";
import store from "@/vuex/store";

const auth = {
  loggedIn() {
    return store.getters.isLogged;
  },
};

export default [
  {
    path: "/custom-tab_:authKey",
    name: "Mobile",
    component: VoxoMobile,
    meta: {
      layout: layouts.contenOnly,
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true,
      searchable: true,
      tags: ["pages"],
      roles: [1, 3, 5, 7, 9, 11, 12, 13, 14],
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      layout: layouts.contenOnly,
    },
  },
  {
    path: "/sso",
    name: "sso",
    component: SSOProcessing,
    meta: {
      layout: layouts.contenOnly,
    },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: {
      layout: layouts.contenOnly,
    },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPassword,
    meta: {
      layout: layouts.contenOnly,
    },
  },
  {
    path: "/setup-mfa",
    name: "setup-mfa",
    component: SetupMFA,
    meta: {
      layout: layouts.contenOnly,
    },
    beforeEnter(to, from, next) {
      if (auth.loggedIn()) {
        return next({ path: "/omnia/contacts" });
      }

      if (from.name === "login") {
        return next();
      }

      next({ path: "/login" });
    },
  },
  {
    path: "/verify-mfa",
    name: "verify-mfa",
    component: VerifyMFA,
    meta: {
      layout: layouts.contenOnly,
    },
    beforeEnter(to, from, next) {
      if (auth.loggedIn()) {
        return next({ path: "/omnia/contacts" });
      }

      if (from.name === "login" || from.name === "setup-mfa") {
        return next();
      }

      next({ path: "/login" });
    },
  },
  {
    path: "/validate-mfa",
    name: "validate-mfa",
    component: ValidateMFA,
    meta: {
      layout: layouts.contenOnly,
    },
    beforeEnter(to, from, next) {
      if (auth.loggedIn()) {
        return next({ path: "/omnia/contacts" });
      }

      if (from.name === "login") {
        return next();
      }

      next({ path: "/login" });
    },
  },
  {
    path: "*",
    name: "not-found",
    component: NotFound,
    meta: {
      layout: layouts.contenOnly,
    },
  },
  {
    path: "/salesforce",
    name: "salesforce",
    component: SalesforceIntegration,
    meta: {
      auth: true,
      layout: layouts.contenOnly,
    },
  },
  {
    path: "/hubspot",
    name: "hubspot",
    component: HubspotIntegration,
    meta: {
      auth: true,
      layout: layouts.contenOnly,
    },
  },
];
